import RuleRic1 from './RIC_1'

export default {
  ...RuleRic1,
  gradeLevelId: 3
}
